import { abbreviateNumbers, currencySymbol, formatNumber } from "utills/helpers";
import { IAddonSales } from "../table";

interface AddonsCardProps {
  data?: IAddonSales[];
  pageSize: number;
  currentPage: number;
  isLoading: boolean;
  currency?: string;
}

export const AddonsCard = ({
  data = [],
  pageSize = 10,
  currentPage = 1,
  isLoading,
  currency,
}: AddonsCardProps) => {
  if (isLoading) {
    return (
      <ul className="bg-white">
        {[...Array(10).keys()].map((index: number) => (
            <div
              key={index}
              className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
            >
              {[...Array(6).keys()].map((childIndex: number) => (
                  <li
                    key={childIndex}
                    className="relative flex items-start justify-between gap-x-6"
                  >
                    <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                    <div className="h-3 bg-gray-200 rounded-full w-20 max-w-full" />
                  </li>
                ))}
            </div>
          ))}
      </ul>
    );
  }

  return (
    <ul className="bg-white">
      {data.map((item: IAddonSales, index: number) => (
        <div
          key={index}
          className="flex flex-col gap-y-4 overflow-hidden shadow-md ring-1 ring-gray-900/5 [&:not(:last-child)]:mb-4 p-4 rounded-xl"
        >
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">No</p>
            <p className="flex-1 text-right text-sm leading-6">
              {(currentPage - 1) * pageSize + 1 + index}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Addon Name</p>
            <p className="flex-1 text-right text-sm leading-6">{item.addon_name || "-"}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Variant</p>
            <p className="flex-1 text-right text-sm leading-6">{item.variant_label || "-"}</p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Quantity</p>
            <p
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.quantity ?? 0)}
            >
              {abbreviateNumbers(item.quantity ?? 0)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Unit price</p>
            <p
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.unit_price ?? 0)}
            >
              {currencySymbol(currency)} {abbreviateNumbers(item.unit_price ?? 0)}
            </p>
          </li>
          <li className="relative flex items-start justify-between gap-x-6">
            <p className="flex-1 text-sm font-semibold leading-6">Gross revenue</p>
            <p
              className="flex-1 text-right text-sm leading-6"
              data-tooltip-id="tooltip"
              data-tooltip-content={formatNumber(item.gross_revenue ?? 0)}
            >
              {currencySymbol(currency)} {abbreviateNumbers(item.gross_revenue ?? 0)}
            </p>
          </li>
        </div>
      ))}
      {data.length === 0 ? (
        <li className="text-center text-sm leading-6">No data</li>
      ) : <></>}
    </ul>
  );
};
